/** Fired once when the consent-gated browser PostHog singleton is ready. */
export const POSTHOG_BROWSER_INITIALIZED_EVENT = "posthog_browser_initialized";

/** Fired after the singleton's live distinct id equals the signed-in Clerk id. */
export const POSTHOG_IDENTITY_READY_EVENT = "posthog_identity_ready";
